import React, { useState } from "react";
import Sidebar from "../../components/Super Admin/SideBar/Sidebar";
import Topbar from "../../components/Super Admin/TopBar/TopbarCenterManagement";
import CentersTable from "../../components/Super Admin/Center Management/CentersTable";
import ReleasedAppointmentsTable from "../../components/Super Admin/Center Management/ReleasedAppointmentTable";
import "../../css/ReleaseAppointmentPage.css";

const ReleaseAppointmentPage: React.FC = () => {
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  return (
    <>
        <Topbar />
        <CentersTable onReleaseSuccess={() => setRefreshTrigger(prev => prev + 1)} />
        <ReleasedAppointmentsTable refreshTrigger={refreshTrigger} />
    </>
  );
};

export default ReleaseAppointmentPage;
